import { z } from 'zod';
/**
 * Konto zurücksetzen (Einrichtung → Daten löschen): Das Unternehmen löscht selbst alle seine Daten endgültig und beginnt wieder bei null. Die Löschung geschieht in der
 * Datenbank, nicht als Vermerk, und lässt sich nicht rückgängig machen.
 */
/** Dieser Text muss zur Bestätigung abgetippt werden */
export const ACCOUNT_RESET_PHRASE = 'ALLES LÖSCHEN';
export const resetAccountInput = z.object({
    /** Das Passwort des angemeldeten Benutzers, damit niemand mit einer offenen Sitzung das Konto leeren kann */
    password: z.string().min(1, 'Bitte geben Sie Ihr Passwort ein.').max(200),
    confirmation: z.string().refine((v) => v.trim() === ACCOUNT_RESET_PHRASE, `Bitte geben Sie zur Bestätigung „${ACCOUNT_RESET_PHRASE}“ ein.`),
});
//# sourceMappingURL=account-reset.js.map